var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Light Blue Circle",
    viewBox: "0 0 23.041 23.041",
    width: 23.041,
    height: 23.041,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "light_blue_circle",
    fill: "#1DA1F2",
    cx: 11.5205,
    cy: 11.5205,
    r: 11.5205
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCircleIcon);
export default __webpack_public_path__ + "static/media/blue-circle-icon.1630ed5228afc5b078b67e7cadf241c6.svg";
export { ForwardRef as ReactComponent };